import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Modal
} from "@mui/material";
import "./MfidForm.css";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import LoadingSpinner from "../../../Loading/component";
import { useNavigate } from "react-router-dom";
import leftArrow from "../../../../assests/leftArrow.svg";
import search from "../../../../assests/search.svg";
import Table from "react-bootstrap/Table";

const MfidFormComponent = (props) => {
  const [selectedVendor, setSelectedVendor] = useState({ id: "", name: "" });
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const goback = () => navigate(-1);
  const handleClick = () => navigate(-1);
  const handleCreateNewVendor = () => {
    handleClose();
    navigate("/home/configuration/productsvariantdetails/createnewvendor");
  };

  const handleVendorSelect = (vendor) => {
    setSelectedVendor({ id: vendor.id, name: vendor.name });
    props.setFormDataMfids((prevState) => ({
      ...prevState,
      manufacturerId: vendor.id,
      vendorName: vendor.name,
    }));
    handleClose();
  };

  const handlePurchaseTypeChange = (event) => {
    const { value } = event.target;
    const selectedType = props.dropdownData.find((item) => item.id === value);
    props.setFormDataMfids((prevState) => ({
      ...prevState,
      zohoItemTypeId: value,
      zohoItemTypeName: selectedType ? selectedType.name : "",
    }));
  };

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="mfid-form-container">
          <div>
            <Sidebar />
          </div>

          <div className="mfid-main-content">
            <div className="mfid-page-header">
              <img
                onClick={handleClick}
                className="mfid-back-button"
                src={leftArrow}
                alt="Back"
              />
              <h2 className="mfid-page-title">Create New MFID</h2>
            </div>

            <div className="mfid-form-wrapper">
              <Box className="mfid-form-box">
                <FormControl fullWidth className="mfid-form-control">
                  <InputLabel>Purchase Type</InputLabel>
                  <Select
                    name="zohoItemTypeId"
                    value={props.formDataMfids?.zohoItemTypeId || ""}
                    onChange={handlePurchaseTypeChange}
                    label="Purchase Type"
                  >
                    <MenuItem value="">Select Purchase Type</MenuItem>
                    {props.dropdownData &&
                      props.dropdownData.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                <Box className="mfid-vendor-select-section">
                  <TextField
                    fullWidth
                    name="vendorName"
                    value={selectedVendor.name || ""}
                    InputProps={{ readOnly: true }}
                    label="Vendor Name"
                    className="mfid-vendor-name-input"
                    placeholder="Select a vendor"
                  />
                  <Button
                    variant="outlined"
                    onClick={handleOpen}
                    className="mfid-select-vendor-button"
                  >
                    Select Vendor
                  </Button>
                </Box>

                <Box className="mfid-price-fields-section">
                  <TextField
                    fullWidth
                    name="vendorPrice"
                    value={props.formDataMfids?.vendorPrice || ""}
                    onChange={props.handleChangeCreateMfids}
                    label="Purchase Price"
                    type="number"
                    className="mfid-price-input"
                    inputProps={{ min: 0, step: "0.01" }}
                  />
                  <TextField
                    fullWidth
                    name="mrp"
                    value={props.formDataMfids?.mrp || ""}
                    onChange={props.handleChangeCreateMfids}
                    label="M.R.P"
                    type="number"
                    className="mfid-price-input"
                    inputProps={{ min: 0, step: "0.01" }}
                  />
                </Box>

                <TextField
                  fullWidth
                  name="offerPrice"
                  value={props.formDataMfids?.offerPrice || ""}
                  onChange={props.handleChangeCreateMfids}
                  label="Selling Price"
                  type="number"
                  className="mfid-price-input"
                  inputProps={{ min: 0, step: "0.01" }}
                />

                <Box className="mfid-form-button-group">
                  <Button className="mfid-cancel-button" onClick={goback}>
                    Cancel
                  </Button>
                  <Button
                    className="mfid-save-button"
                    onClick={props.handleCreateMfidApi}
                  >
                    Save
                  </Button>
                </Box>
              </Box>
            </div>

            {/* Vendor Selection Modal */}
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="vendor-search-modal"
              className="mfid-modal-overlay"
            >
              <div className="mfid-modal-container">
                <div className="mfid-modal-content">
                  <div className="mfid-modal-header">
                    <img
                      onClick={handleClose}
                      className="mfid-modal-back-button"
                      src={leftArrow}
                      alt="Back"
                    />
                    <h2 className="mfid-modal-title">Search Vendor</h2>
                  </div>

                  <div className="mfid-search-section">
                    <div className="mfid-search-container">
                      <div className="mfid-search-input-container">
                        <input
                          type="search"
                          placeholder="Search by Vendor Name/ID"
                          onChange={(e) => props.handleSearch(e.target.value)}
                          className="mfid-search-input"
                        />
                        <img
                          className="mfid-search-icon"
                          src={search}
                          alt="Search"
                        />
                      </div>
                      <Button
                        variant="contained"
                        className="mfid-create-vendor-button"
                        onClick={handleCreateNewVendor}
                      >
                        Create New Vendor
                      </Button>
                    </div>

                    <div className="mfid-table-container">
                      <Table striped hover className="mfid-vendor-table">
                        <thead>
                          <tr>
                            <th className="mfid-table-id">ID</th>
                            <th className="mfid-table-name">Vendor Name</th>
                            <th className="mfid-table-phone">Phone Number</th>
                            <th className="mfid-table-email">Email ID</th>
                            <th className="mfid-table-select">Select</th>
                          </tr>
                        </thead>

                        <tbody>
                          {props.filteredVendorList &&
                          props.filteredVendorList.length > 0 ? (
                            props.filteredVendorList.map((el) => (
                              <tr key={el.id} className="mfid-table-row">
                                <td className="mfid-table-cell">{el.id}</td>
                                <td className="mfid-table-cell">{el.name}</td>
                                <td className="mfid-table-cell">
                                  {el.phoneNumber || "-"}
                                </td>
                                <td className="mfid-table-cell">
                                  {el.email || "-"}
                                </td>
                                <td className="mfid-table-cell">
                                  <input
                                    id={el.id}
                                    type="radio"
                                    className="mfid-vendor-radio"
                                    onChange={() => handleVendorSelect(el)}
                                    checked={selectedVendor.id === el.id}
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr className="mfid-table-row">
                              <td
                                colSpan="5"
                                className="mfid-no-vendors-message"
                              >
                                No vendors found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>

                  <div className="mfid-modal-button-group">
                    <Button
                      variant="outlined"
                      className="mfid-modal-cancel-button"
                      onClick={handleClose}
                    >
                      Back
                    </Button>
                    <Button
                      variant="contained"
                      className="mfid-modal-save-button"
                      onClick={handleClose}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      )}
    </>
  );
};

export default MfidFormComponent;